angular.module("fdm.common.uiBootstrapOverrides", []).run(["$templateCache", ($templateCache) => {
    //$templateCache.put("template/modal/window.html",
    //    "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n" +
    //    "    modal-animation-class=\"fade\"\n" +
    //    "    modal-in-class=\"in\"\n" +
    //    "	ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" ng-click=\"close($event)\">\n" +
    //    "    <div class=\"modal-dialog\" ng-class=\"size ? 'modal-' + size : ''\"><div class=\"modal-content\" modal-transclude></div></div>\n" +
    //    "</div>\n" +
    //    "");
}]);